import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { browserName, browserVersion, osName, osVersion } from 'react-device-detect';

import { trackEvent, useGetActiveTool } from '@clatter/platform';
import { authSelectors } from '../store';

type TrackEventPayload = {
  type: string;
  data: {
    app_version: string;
    browser_name: string;
    browser_version: string;
    current_url: string;
    screen_height: number;
    screen_width: number;
    os_name: string;
    os_version: string;
    tool: string;
    user_id: string | undefined;
    user_email: string;
    user_name: string;
    [key: string]: unknown;
  };
};

type TrackEventFn = (payload: TrackEventPayload) => ReturnType<typeof trackEvent>;
const typedTrackEvent = trackEvent as unknown as TrackEventFn;

export const useNgTrackEvent = () => {
  const dispatch = useDispatch();
  const activeTool = useGetActiveTool();
  const user = useSelector(authSelectors.getUserAuthState)?.user;

  return useCallback(
    (type: string, data: Record<string, unknown> = {}) => {
      if (!user?.sub) return;

      dispatch(
        typedTrackEvent({
          type,
          data: {
            app_version: process.env['NX_PUBLIC_APP_VERSION'] || 'dev',
            browser_name: browserName,
            browser_version: browserVersion,
            current_url: window.location.href,
            screen_height: window.innerHeight,
            screen_width: window.innerWidth,
            os_name: osName,
            os_version: osVersion,
            tool: activeTool?.slug?.toUpperCase() || 'NG',
            user_id: user.sub.split('|').pop(), // strip the "auth0|" prefix to match the user_id format used across legacy tools
            user_email: user.email,
            user_name: user.name,
            ...data,
          },
        }),
      );
    },
    [dispatch, activeTool?.slug, user?.sub, user?.email, user?.name],
  );
};
